import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

const add = async (userId: string, tradingPlatformId: number, categoryId: number) => {
  const { data: updateData, error: updateError } = await supabase
    .from('trading_platforms_users')
    .insert({
      user_id: userId,
      trading_platform_id: tradingPlatformId,
      category_id: categoryId,
    })

  if (updateError) {
    throw new Error(updateError.message)
  }

  return updateData
}

export default function useAddUserTrading(userId: string, categoryId: number) {
  return useMutation((tradingPlatformId: number) => add(userId, tradingPlatformId, categoryId), {
    onSuccess: async (data) => data,
  })
}
